import { restHost } from './utils';

const TOKEN_KEY = 'token';

export function getToken() {
  const fromLocal = localStorage.getItem(TOKEN_KEY);
  if (fromLocal) {
    return fromLocal;
  }
  const legacy = sessionStorage.getItem(TOKEN_KEY);
  if (legacy) {
    localStorage.setItem(TOKEN_KEY, legacy);
    sessionStorage.removeItem(TOKEN_KEY);
    return legacy;
  }
  return null;
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/** Validates the token with the backend (async; do not use sync XHR). */
export async function validateStoredToken() {
  const token = getToken();
  if (!token) {
    return false;
  }
  const url = `${restHost}/validToken?token=${encodeURIComponent(token)}`;
  try {
    const res = await fetch(url, { method: 'GET', credentials: 'same-origin' });
    return res.ok;
  } catch {
    return false;
  }
}
